import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextComponent } from '../../common/text/text.component';

export namespace NCmsQuickLinks {
    export interface IComponentData extends NICmsContentComponent.IData, NTextComponent.ITextContent {
        linksVariant: 'text' | 'textWithImage';
        links: IQuickLink[];
        darkLinkBg?: boolean;
    }
    export interface IQuickLink {
        text: string;
        url: string;
        image?: string;
    }
}

@ICmsComponent<CmsQuickLinksComponent>({
    id: 'quick-links',
    name: 'Quick Links',
    tags: ['categories', 'carousel', 'quick links', 'links'],
    fields: [
        ...NTextComponent.getFields(false, true, false),
        <NICmsContentField.IToggleField>{
            key: 'darkLinkBg',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Dark link background',
            labels: { true: 'Dark background', false: 'Light background' },
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            itemName: 'Link',
            itemNameField: 'title',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text',
                    default: 'Quicklink',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Url',
                    default: '/',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                }
            ],
            defaultSize: 4
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    selector: 'cms-quick-links',
    templateUrl: './cms-quick-links.html',
    styleUrls: ['./cms-quick-links.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsQuickLinks.IComponentData;
}
